// // import React, { useState, useEffect, useRef } from "react";
// // import { Link, useNavigate } from "react-router-dom";
// // import httpClient from "../../utils/httpClients";
// // import Loader from "../../loader/loader";
// // import "slick-carousel/slick/slick.css";
// // import "slick-carousel/slick/slick-theme.css";
// // import Slider from "react-slick";

// // function Podcast() {
// //   const navigate = useNavigate();
// //   const slidergenRef = useRef(null);

// //   const [allPopularPodcasts, setAllPopularPodcasts] = useState([]);
// //   const [allFeaturedPodcasts, setAllFeaturedPodcasts] = useState([]);
// //   const [popularPodcasts, setPopularPodcasts] = useState([]);
// //   const [featuredPodcasts, setFeaturedPodcasts] = useState([]);
// //   const [genres, setGenres] = useState([]);
// //   const [loadingPopular, setLoadingPopular] = useState(false);
// //   const [loadingFeatured, setLoadingFeatured] = useState(false);
// //   const [loadingGenres, setLoadingGenres] = useState(false);
// //   const [error, setError] = useState("");

// //   // Pagination states
// //   const [popularCurrentPage, setPopularCurrentPage] = useState(1);
// //   const [featuredCurrentPage, setFeaturedCurrentPage] = useState(1);
// //   const [popularTotalPages, setPopularTotalPages] = useState(1);
// //   const [featuredTotalPages, setFeaturedTotalPages] = useState(1);

// //   const itemsPerPage = 8;

// //   useEffect(() => {
// //     fetchAllPopularPodcasts();
// //     fetchAllFeaturedPodcasts();
// //     fetchGenres();
// //   }, []);

// //   // Sabhi popular podcasts ek saath fetch karein
// //   const fetchAllPopularPodcasts = async () => {
// //     try {
// //       setLoadingPopular(true);
// //       const res = await httpClient.get(
// //         `/user/podcast/popular-podcast?pageSize=100&pageNumber=1` // Large page size to get all
// //       );

// //       if (res.data && res.data.success) {
// //         const allData = res.data.data?.popularData || [];
// //         setAllPopularPodcasts(allData);

// //         // Pagination calculate karein
// //         const totalPages = Math.ceil(allData.length / itemsPerPage);
// //         setPopularTotalPages(totalPages);

// //         // Pehle page ke items show karein
// //         updatePopularPodcastsPage(1, allData);
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching popular podcasts");
// //     } finally {
// //       setLoadingPopular(false);
// //     }
// //   };

// //   // Sabhi featured podcasts ek saath fetch karein
// //   const fetchAllFeaturedPodcasts = async () => {
// //     try {
// //       setLoadingFeatured(true);
// //       const res = await httpClient.get(
// //         `/user/podcast/featured-podcast?pageSize=100&pageNumber=1` // Large page size to get all
// //       );

// //       if (res.data && res.data.success) {
// //         const allData = res.data.data?.featuredData || [];
// //         setAllFeaturedPodcasts(allData);

// //         // Pagination calculate karein
// //         const totalPages = Math.ceil(allData.length / itemsPerPage);
// //         setFeaturedTotalPages(totalPages);

// //         // Pehle page ke items show karein
// //         updateFeaturedPodcastsPage(1, allData);
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching featured podcasts");
// //     } finally {
// //       setLoadingFeatured(false);
// //     }
// //   };

// //   // Current page ke hisaab se popular podcasts update karein
// //   const updatePopularPodcastsPage = (page, data = allPopularPodcasts) => {
// //     const startIndex = (page - 1) * itemsPerPage;
// //     const endIndex = startIndex + itemsPerPage;
// //     const pageData = data.slice(startIndex, endIndex);

// //     setPopularPodcasts(pageData);
// //     setPopularCurrentPage(page);
// //   };

// //   // Current page ke hisaab se featured podcasts update karein
// //   const updateFeaturedPodcastsPage = (page, data = allFeaturedPodcasts) => {
// //     const startIndex = (page - 1) * itemsPerPage;
// //     const endIndex = startIndex + itemsPerPage;
// //     const pageData = data.slice(startIndex, endIndex);

// //     setFeaturedPodcasts(pageData);
// //     setFeaturedCurrentPage(page);
// //   };

// //   // Popular podcasts ka page change
// //   const handlePopularPageChange = (page) => {
// //     updatePopularPodcastsPage(page);
// //     window.scrollTo({ top: 0, behavior: 'smooth' });
// //   };

// //   // Featured podcasts ka page change
// //   const handleFeaturedPageChange = (page) => {
// //     updateFeaturedPodcastsPage(page);
// //     window.scrollTo({ top: 0, behavior: 'smooth' });
// //   };

// //   const fetchGenres = async () => {
// //     try {
// //       setLoadingGenres(true);
// //       const res = await httpClient.get(
// //         "user/podcast/genres-podcast?pageSize=10&pageNumber=1"
// //       );
// //       if (res.data && res.data.success) {
// //         const Genres = res.data.data?.genresData || [];
// //         setGenres(Genres);
// //       } else {
// //         setError("Failed to fetch genres");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error loading genres. Please try again later.");
// //     } finally {
// //       setLoadingGenres(false);
// //     }
// //   };

// //   useEffect(() => {
// //     window.scrollTo(0, 0);
// //   }, []);

// //   // Simple Pagination Component
// //   const Pagination = ({ currentPage, totalPages, onPageChange, section }) => {
// //     if (totalPages <= 1) return null;

// //     return (
// //       <div className="pagination-container mt-4">
// //         <div className="d-flex justify-content-between align-items-center">
// //           <button
// //             className="btn btn-outline-primary"
// //             onClick={() => onPageChange(currentPage - 1)}
// //             disabled={currentPage === 1}
// //           >
// //             ← Previous
// //           </button>

// //           <span className="mx-3">
// //             Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
// //           </span>

// //           <button
// //             className="btn btn-outline-primary"
// //             onClick={() => onPageChange(currentPage + 1)}
// //             disabled={currentPage === totalPages}
// //           >
// //             Next →
// //           </button>
// //         </div>

// //         {/* Page numbers */}
// //         <div className="text-center mt-2">
// //           {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
// //             <button
// //               key={page}
// //               className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
// //               onClick={() => onPageChange(page)}
// //             >
// //               {page}
// //             </button>
// //           ))}
// //         </div>
// //       </div>
// //     );
// //   };

// //   const settings = {
// //     slidesToShow: 5,
// //     slidesToScroll: 1,
// //     infinite: true,
// //     arrows: false,
// //     dots: false,
// //     responsive: [
// //       {
// //         breakpoint: 1200,
// //         settings: { slidesToShow: 3 },
// //       },
// //       {
// //         breakpoint: 992,
// //         settings: { slidesToShow: 2 },
// //       },
// //       {
// //         breakpoint: 576,
// //         settings: { slidesToShow: 1 },
// //       },
// //     ],
// //   };

// //   const PodcastCard = ({ podcast }) => (
// //     <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
// //       <div className="live">
// //         <Link
// //           to={`/podcast-episode/${podcast._id}`}
// //           className="live__cover open-video"
// //         >
// //           <img
// //             src={podcast.coverImageUrl}
// //             alt={podcast.title}
// //             style={{ width: '100%', height: '200px', objectFit: 'cover' }}
// //           />
// //         </Link>
// //         <h5 className="live__title mt-2">
// //           <Link to={`/podcast-episode/${podcast._id}`}>
// //             {podcast.genre?.name || 'Unknown Genre'}
// //           </Link>
// //         </h5>
// //         <h3 className="live__title">
// //           <Link to={`/podcast-episode/${podcast._id}`}>
// //             {podcast.title}
// //           </Link>
// //         </h3>
// //         <p className="live__artist">{podcast.artist}</p>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <div className="content-inner pb-0 container-fluid" id="page_layout">
// //       {error && <div className="alert alert-danger">{error}</div>}

// //       {/* Popular Podcasts */}
// //       <div className="row row--grid">
// //         <div className="col-12">
// //           <h2 className="card-title text-capitalize mt-3">
// //             Popular Podcasts
// //             <small className="text-muted ms-2">
// //               (Total: {allPopularPodcasts.length} podcasts)
// //             </small>
// //           </h2>
// //         </div>

// //         {loadingPopular ? (
// //           <div className="col-12 text-center py-5">
// //             <div className="spinner-border text-primary" role="status">
// //               <span className="visually-hidden">Loading...</span>
// //             </div>
// //             <p className="mt-2">Loading popular podcasts...</p>
// //           </div>
// //         ) : (
// //           <>
// //             <div className="row">
// //               {popularPodcasts.length > 0 ? (
// //                 popularPodcasts.map((podcast) => (
// //                   <PodcastCard key={podcast._id} podcast={podcast} />
// //                 ))
// //               ) : (
// //                 <div className="col-12 text-center py-5">
// //                   <p>No popular podcasts found.</p>
// //                 </div>
// //               )}
// //             </div>

// //             <Pagination
// //               currentPage={popularCurrentPage}
// //               totalPages={popularTotalPages}
// //               onPageChange={handlePopularPageChange}
// //               section="popular"
// //             />
// //           </>
// //         )}
// //       </div>

// //       {/* Featured Podcasts */}
// //       <div className="row row--grid mt-5">
// //         <div className="col-12">
// //           <h2 className="card-title text-capitalize mt-3">
// //             Featured Podcasts
// //             <small className="text-muted ms-2">
// //               (Total: {allFeaturedPodcasts.length} podcasts)
// //             </small>
// //           </h2>
// //         </div>

// //         {loadingFeatured ? (
// //           <div className="col-12 text-center py-5">
// //             <div className="spinner-border text-primary" role="status">
// //               <span className="visually-hidden">Loading...</span>
// //             </div>
// //             <p className="mt-2">Loading featured podcasts...</p>
// //           </div>
// //         ) : (
// //           <>
// //             <div className="row">
// //               {featuredPodcasts.length > 0 ? (
// //                 featuredPodcasts.map((podcast) => (
// //                   <PodcastCard key={podcast._id} podcast={podcast} />
// //                 ))
// //               ) : (
// //                 <div className="col-12 text-center py-5">
// //                   <p>No featured podcasts found.</p>
// //                 </div>
// //               )}
// //             </div>

// //             <Pagination
// //               currentPage={featuredCurrentPage}
// //               totalPages={featuredTotalPages}
// //               onPageChange={handleFeaturedPageChange}
// //               section="featured"
// //             />
// //           </>
// //         )}
// //       </div>

// //       <div className="row">
// //               <div className="col-lg-12 mb-5">
// //                 <div className="card-header mb-3">
// //                   <div className="header-title">
// //                     <h4 className="card-title text-capitalize">
// //                       Top genres for you
// //                     </h4>
// //                   </div>
// //                   <div className="common-album position-relative d-lg-block d-none">
// //                     {/* Custom Prev/Next */}
// //                     <div
// //                       className="swiper-button-prev"
// //                       onClick={() =>
// //                         slidergenRef.current && slidergenRef.current.slickPrev()
// //                       }
// //                     >
// //                       <svg
// //                         xmlns="http://www.w3.org/2000/svg"
// //                         width={18}
// //                         height={19}
// //                         viewBox="0 0 18 19"
// //                         fill="none"
// //                       >
// //                         <path
// //                           d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
// //                           fill="#4A525F"
// //                         />
// //                       </svg>{" "}
// //                     </div>
// //                     <div
// //                       className="swiper-button-next"
// //                       onClick={() =>
// //                         slidergenRef.current && slidergenRef.current.slickNext()
// //                       }
// //                     >
// //                       <svg
// //                         xmlns="http://www.w3.org/2000/svg"
// //                         width={18}
// //                         height={19}
// //                         viewBox="0 0 18 19"
// //                         fill="none"
// //                       >
// //                         <path
// //                           d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
// //                           fill="currentColor"
// //                         />
// //                       </svg>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {loadingGenres ? (
// //                   <div
// //                     className="content-inner pb-0 container-fluid"
// //                     id="page_layout"
// //                   >
// //                     <div
// //                       className="d-flex justify-content-center align-items-center"
// //                       style={{ height: "50vh" }}
// //                     >
// //                       <div
// //                         className="spinner-border text-primary"
// //                         role="status"
// //                       >
// //                         <span className="sr-only">Loading...</span>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 ) : error ? (
// //                   <div className="alert alert-danger" role="alert">
// //                     {error}
// //                   </div>
// //                 ) : (
// //                   <Slider
// //                     ref={slidergenRef}
// //                     {...settings}
// //                     className="overflow-hidden"
// //                   >
// //                     {genres.map((genre) => (
// //                       <div
// //                         key={genre._id}
// //                         className="mb-3 px-2"
// //                         role="group"
// //                         aria-label={`Genre: ${genre.genreName}`}
// //                       >
// //                         <Link
// //                           to={`genre-podcasts`}
// //                           state={{
// //                             genreId: genre._id,
// //                             podcasts: genre.podcasts || [],
// //                             genreName: genre.genreName,
// //                           }}
// //                           className="text-decoration-none"
// //                         >
// //                           <img
// //                             src={
// //                               genre._id?.GenreImageUrl ||
// //                               `${process.env.PUBLIC_URL}/assets/images/dashboard/placeholder.png`
// //                             }
// //                             className="mb-3 img-fluid rounded-3"
// //                             alt={genre.genreName}
// //                             style={{
// //                               height: "220px",
// //                               objectFit: "cover",
// //                               cursor: "pointer",
// //                             }}
// //                           />
// //                           <div className="text-capitalize line-count-1 h5 d-block">
// //                             {genre.genreName}
// //                           </div>
// //                           <small className="fw-normal text-capitalize line-count-1">
// //                             {genre.podcasts
// //                               ? `${genre.podcasts.length} podcasts`
// //                               : "No podcasts"}
// //                           </small>
// //                         </Link>
// //                       </div>
// //                     ))}
// //                   </Slider>
// //                 )}
// //               </div>
// //             </div>
// //     </div>
// //   );
// // }

// // export default Podcast;

// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import httpClient from "../../utils/httpClients";
// import Loader from "../../loader/loader";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";

// function Podcast() {
//   const navigate = useNavigate();
//   const slidergenRef = useRef(null);

//   const [allPopularPodcasts, setAllPopularPodcasts] = useState([]);
//   const [allFeaturedPodcasts, setAllFeaturedPodcasts] = useState([]);
//   const [popularPodcasts, setPopularPodcasts] = useState([]);
//   const [featuredPodcasts, setFeaturedPodcasts] = useState([]);
//   const [genres, setGenres] = useState([]);
//   const [loadingPopular, setLoadingPopular] = useState(false);
//   const [loadingFeatured, setLoadingFeatured] = useState(false);
//   const [loadingGenres, setLoadingGenres] = useState(false);
//   const [error, setError] = useState("");

//   // Pagination states
//   const [popularCurrentPage, setPopularCurrentPage] = useState(1);
//   const [featuredCurrentPage, setFeaturedCurrentPage] = useState(1);
//   const [popularTotalPages, setPopularTotalPages] = useState(1);
//   const [featuredTotalPages, setFeaturedTotalPages] = useState(1);

//   const itemsPerPage = 8;

//   useEffect(() => {
//     fetchAllPopularPodcasts();
//     fetchAllFeaturedPodcasts();
//     fetchGenres();
//   }, []);

//   // API CALL: Add all podcast episodes to queue with type: "track"
//   const addPodcastToQueueAndPlay = async (podcastId, podcastTitle) => {
//     try {
//       const payload = {
//         action: "addAllToQueue",
//         playlistId: podcastId,
//         type: "track"  // As requested
//       };

//       const res = await httpClient.post("/user/queue/queue-controller", payload);

//       if (res.data?.success) {
//         console.log(`✅ All episodes of "${podcastTitle}" added to queue!`);
//         // Optional: You can add toast notification here
//       } else {
//         alert("Failed to add podcast to queue");
//       }
//     } catch (err) {
//       console.error("Failed to add podcast to queue:", err);
//       alert("Failed to add podcast episodes to queue");
//     }
//   };

//   // Sabhi popular podcasts ek saath fetch karein
//   const fetchAllPopularPodcasts = async () => {
//     try {
//       setLoadingPopular(true);
//       const res = await httpClient.get(
//         `/user/podcast/popular-podcast?pageSize=100&pageNumber=1`
//       );

//       if (res.data && res.data.success) {
//         const allData = res.data.data?.popularData || [];
//         setAllPopularPodcasts(allData);

//         const totalPages = Math.ceil(allData.length / itemsPerPage);
//         setPopularTotalPages(totalPages);

//         updatePopularPodcastsPage(1, allData);
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error fetching popular podcasts");
//     } finally {
//       setLoadingPopular(false);
//     }
//   };

//   // Sabhi featured podcasts ek saath fetch karein
//   const fetchAllFeaturedPodcasts = async () => {
//     try {
//       setLoadingFeatured(true);
//       const res = await httpClient.get(
//         `/user/podcast/featured-podcast?pageSize=100&pageNumber=1`
//       );

//       if (res.data && res.data.success) {
//         const allData = res.data.data?.featuredData || [];
//         setAllFeaturedPodcasts(allData);

//         const totalPages = Math.ceil(allData.length / itemsPerPage);
//         setFeaturedTotalPages(totalPages);

//         updateFeaturedPodcastsPage(1, allData);
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error fetching featured podcasts");
//     } finally {
//       setLoadingFeatured(false);
//     }
//   };

//   const updatePopularPodcastsPage = (page, data = allPopularPodcasts) => {
//     const startIndex = (page - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const pageData = data.slice(startIndex, endIndex);

//     setPopularPodcasts(pageData);
//     setPopularCurrentPage(page);
//   };

//   const updateFeaturedPodcastsPage = (page, data = allFeaturedPodcasts) => {
//     const startIndex = (page - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const pageData = data.slice(startIndex, endIndex);

//     setFeaturedPodcasts(pageData);
//     setFeaturedCurrentPage(page);
//   };

//   const handlePopularPageChange = (page) => {
//     updatePopularPodcastsPage(page);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const handleFeaturedPageChange = (page) => {
//     updateFeaturedPodcastsPage(page);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const fetchGenres = async () => {
//     try {
//       setLoadingGenres(true);
//       const res = await httpClient.get(
//         "user/podcast/genres-podcast?pageSize=10&pageNumber=1"
//       );
//       if (res.data && res.data.success) {
//         const Genres = res.data.data?.genresData || [];
//         setGenres(Genres);
//       } else {
//         setError("Failed to fetch genres");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading genres. Please try again later.");
//     } finally {
//       setLoadingGenres(false);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // Pagination Component
//   const Pagination = ({ currentPage, totalPages, onPageChange, section }) => {
//     if (totalPages <= 1) return null;

//     return (
//       <div className="pagination-container mt-4">
//         <div className="d-flex justify-content-between align-items-center">
//           <button
//             className="btn btn-outline-primary"
//             onClick={() => onPageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             ← Previous
//           </button>

//           <span className="mx-3">
//             Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
//           </span>

//           <button
//             className="btn btn-outline-primary"
//             onClick={() => onPageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           >
//             Next →
//           </button>
//         </div>

//         <div className="text-center mt-2">
//           {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
//             <button
//               key={page}
//               className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
//               onClick={() => onPageChange(page)}
//             >
//               {page}
//             </button>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   const settings = {
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     infinite: true,
//     arrows: false,
//     dots: false,
//     responsive: [
//       {
//         breakpoint: 1200,
//         settings: { slidesToShow: 3 },
//       },
//       {
//         breakpoint: 992,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 576,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//   };

//   // UPDATED PodcastCard - SAME FOR POPULAR & FEATURED
//   const PodcastCard = ({ podcast }) => (
//     <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
//       <div className="live">
//         {/* IMAGE CLICK → Add All Episodes to Queue */}
//         <div
//           className="live__cover position-relative"
//           style={{ cursor: "pointer" }}
//           onClick={() => addPodcastToQueueAndPlay(podcast._id, podcast.title)}
//         >
//           <img
//             src={podcast.coverImageUrl}
//             alt={podcast.title}
//             style={{
//               width: '100%',
//               height: '200px',
//               objectFit: 'cover',
//               borderRadius: '8px',
//               transition: 'transform 0.3s ease'
//             }}
//           />

//           {/* HOVER OVERLAY - Play Button */}
//           <div
//             className="position-absolute inset-0 rounded-3 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 opacity-0"
//             style={{
//               transition: 'all 0.3s ease',
//               zIndex: 2
//             }}
//           >
//             <i
//               className="fas fa-play text-white"
//               style={{
//                 fontSize: '48px',
//                 filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))'
//               }}
//             ></i>
//           </div>
//         </div>

//         {/* GENRE LINK → Go to episodes page
//         <h5 className="live__title mt-2">
//           <Link to={`/podcast-episode/${podcast._id}`} className="text-black text-decoration-none">
//             {podcast.genre?.name || 'Unknown Genre'}
//           </Link>
//         </h5> */}

//         {/* TITLE LINK → Go to episodes page */}
//         <h3 className="live__title">
//           <Link to={`/podcast-episode/${podcast._id}`} className="text-black text-decoration-none">
//             {podcast.title}
//           </Link>
//         </h3>

//         <p className="live__artist text-muted">{podcast.artist || 'Unknown Artist'}</p>
//       </div>
//     </div>
//   );

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       {error && <div className="alert alert-danger">{error}</div>}

//       {/* POPULAR PODCASTS */}
//       <div className="row row--grid">
//         <div className="col-12">
//           <h2 className="card-title text-capitalize mt-3">
//             Popular Podcasts
//             <small className="text-muted ms-2">
//               (Total: {allPopularPodcasts.length} podcasts)
//             </small>
//           </h2>
//         </div>

//         {loadingPopular ? (
//           <div className="col-12 text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-2">Loading popular podcasts...</p>
//           </div>
//         ) : (
//           <>
//             <div className="row">
//               {popularPodcasts.length > 0 ? (
//                 popularPodcasts.map((podcast) => (
//                   <PodcastCard key={podcast._id} podcast={podcast} />
//                 ))
//               ) : (
//                 <div className="col-12 text-center py-5">
//                   <p>No popular podcasts found.</p>
//                 </div>
//               )}
//             </div>

//             <Pagination
//               currentPage={popularCurrentPage}
//               totalPages={popularTotalPages}
//               onPageChange={handlePopularPageChange}
//               section="popular"
//             />
//           </>
//         )}
//       </div>

//       {/* FEATURED PODCASTS - SAME LOGIC */}
//       <div className="row row--grid mt-5">
//         <div className="col-12">
//           <h2 className="card-title text-capitalize mt-3">
//             Featured Podcasts
//             <small className="text-muted ms-2">
//               (Total: {allFeaturedPodcasts.length} podcasts)
//             </small>
//           </h2>
//         </div>

//         {loadingFeatured ? (
//           <div className="col-12 text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-2">Loading featured podcasts...</p>
//           </div>
//         ) : (
//           <>
//             <div className="row">
//               {featuredPodcasts.length > 0 ? (
//                 featuredPodcasts.map((podcast) => (
//                   <PodcastCard key={podcast._id} podcast={podcast} />
//                 ))
//               ) : (
//                 <div className="col-12 text-center py-5">
//                   <p>No featured podcasts found.</p>
//                 </div>
//               )}
//             </div>

//             <Pagination
//               currentPage={featuredCurrentPage}
//               totalPages={featuredTotalPages}
//               onPageChange={handleFeaturedPageChange}
//               section="featured"
//             />
//           </>
//         )}
//       </div>

//       {/* GENRES SLIDER */}
//       <div className="row">
//         <div className="col-lg-12 mb-5">
//           <div className="card-header mb-3">
//             <div className="header-title">
//               <h4 className="card-title text-capitalize">
//                 Top genres for you
//               </h4>
//             </div>
//             <div className="common-album position-relative d-lg-block d-none">
//               <div
//                 className="swiper-button-prev"
//                 onClick={() =>
//                   slidergenRef.current && slidergenRef.current.slickPrev()
//                 }
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width={18}
//                   height={19}
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
//                     fill="#4A525F"
//                   />
//                 </svg>
//               </div>
//               <div
//                 className="swiper-button-next"
//                 onClick={() =>
//                   slidergenRef.current && slidergenRef.current.slickNext()
//                 }
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width={18}
//                   height={19}
//                   viewBox="0 0 18 19"
//                   fill="none"
//                 >
//                   <path
//                     d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
//                     fill="currentColor"
//                   />
//                 </svg>
//               </div>
//             </div>
//           </div>

//           {loadingGenres ? (
//             <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
//               <div className="spinner-border text-primary" role="status">
//                 <span className="sr-only">Loading...</span>
//               </div>
//             </div>
//           ) : error ? (
//             <div className="alert alert-danger" role="alert">
//               {error}
//             </div>
//           ) : (
//             <Slider ref={slidergenRef} {...settings} className="overflow-hidden">
//               {genres.map((genre) => (
//                 <div key={genre._id} className="mb-3 px-2">
//                   <Link
//                     to={`genre-podcasts`}
//                     state={{
//                       genreId: genre._id,
//                       podcasts: genre.podcasts || [],
//                       genreName: genre.genreName,
//                     }}
//                     className="text-decoration-none"
//                   >
//                     <img
//                       src={
//                         genre._id?.GenreImageUrl ||
//                         `${process.env.PUBLIC_URL}/assets/images/dashboard/placeholder.png`
//                       }
//                       className="mb-3 img-fluid rounded-3"
//                       alt={genre.genreName}
//                       style={{
//                         height: "220px",
//                         objectFit: "cover",
//                         cursor: "pointer",
//                       }}
//                     />
//                     <div className="text-capitalize line-count-1 h5 d-block">
//                       {genre.genreName}
//                     </div>
//                     <small className="fw-normal text-capitalize line-count-1">
//                       {genre.podcasts
//                         ? `${genre.podcasts.length} podcasts`
//                         : "No podcasts"}
//                     </small>
//                   </Link>
//                 </div>
//               ))}
//             </Slider>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Podcast;

import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import httpClient from "../../utils/httpClients";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function Podcast() {
  const navigate = useNavigate();
  const slidergenRef = useRef(null);
  const featuredSectionRef = useRef(null);

  const [allPopularPodcasts, setAllPopularPodcasts] = useState([]);
  const [allFeaturedPodcasts, setAllFeaturedPodcasts] = useState([]);
  const [popularPodcasts, setPopularPodcasts] = useState([]);
  const [featuredPodcasts, setFeaturedPodcasts] = useState([]);
  const [genres, setGenres] = useState([]);
  const [loadingPopular, setLoadingPopular] = useState(true);
  const [loadingFeatured, setLoadingFeatured] = useState(true);
  const [loadingGenres, setLoadingGenres] = useState(true);
  const [error, setError] = useState("");

  const [popularCurrentPage, setPopularCurrentPage] = useState(1);
  const [featuredCurrentPage, setFeaturedCurrentPage] = useState(1);
  const [popularTotalPages, setPopularTotalPages] = useState(1);
  const [featuredTotalPages, setFeaturedTotalPages] = useState(1);

  const itemsPerPage = 8;
  const [isMobileView, setIsMobileView] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );

  useEffect(() => {
    fetchAllPopularPodcasts();
    fetchAllFeaturedPodcasts();
    fetchGenres();
    window.scrollTo(0, 0);
  }, []);

  // NAVIGATE ONLY — playback starts when user clicks Play on the destination page
  const playPodcastAndNavigate = (podcastId) => {
    navigate(`/podcast-episode/${podcastId}/podcast`, {
      state: { source: "podcast" },
    });
  };

  const fetchAllPopularPodcasts = async () => {
    try {
      setLoadingPopular(true);
      const res = await httpClient.get(
        `/user/podcast/popular-podcast?pageSize=100&pageNumber=1`,
      );
      if (res.data && res.data.success) {
        const allData = res.data.data?.popularData || [];
        setAllPopularPodcasts(allData);
        const totalPages = Math.ceil(allData.length / itemsPerPage);
        setPopularTotalPages(totalPages);
        updatePopularPodcastsPage(1, allData);
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching popular podcasts");
    } finally {
      setLoadingPopular(false);
    }
  };

  const fetchAllFeaturedPodcasts = async () => {
    try {
      setLoadingFeatured(true);
      const res = await httpClient.get(
        `/user/podcast/featured-podcast?pageSize=100&pageNumber=1`,
      );
      if (res.data && res.data.success) {
        const allData = res.data.data?.featuredData || [];
        setAllFeaturedPodcasts(allData);
        const totalPages = Math.ceil(allData.length / itemsPerPage);
        setFeaturedTotalPages(totalPages);
        updateFeaturedPodcastsPage(1, allData);
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching featured podcasts");
    } finally {
      setLoadingFeatured(false);
    }
  };

  const updatePopularPodcastsPage = (page, data = allPopularPodcasts) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPopularPodcasts(data.slice(startIndex, endIndex));
    setPopularCurrentPage(page);
  };

  const updateFeaturedPodcastsPage = (page, data = allFeaturedPodcasts) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setFeaturedPodcasts(data.slice(startIndex, endIndex));
    setFeaturedCurrentPage(page);
  };

  const handlePopularPageChange = (page) => {
    updatePopularPodcastsPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleFeaturedPageChange = (page) => {
    updateFeaturedPodcastsPage(page);
    if (featuredSectionRef.current) {
      featuredSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const fetchGenres = async () => {
    try {
      setLoadingGenres(true);
      const res = await httpClient.get(
        "user/podcast/genres-podcast?pageSize=10&pageNumber=1",
      );
      if (res.data && res.data.success) {
        setGenres(res.data.data?.genresData || []);
      }
    } catch (err) {
      console.error(err);
      setError("Error loading genres.");
    } finally {
      setLoadingGenres(false);
    }
  };

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;
    return (
      <div className="pagination-container mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <button
            className="btn btn-outline-primary"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="mx-3">
            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
          </span>
          <button
            className="btn btn-outline-primary"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
        <div className="text-center mt-2">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              className={`btn btn-sm mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          ))}
        </div>
      </div>
    );
  };
  
  const settings = {
    slidesToShow: isMobileView ? 2 : 5,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  // FINAL CARD - Image Click = Queue + Navigate
  const PodcastCard = ({ podcast }) => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
      <div className="live">
        <div
          className="live__cover position-relative"
          style={{ cursor: "pointer" }}
          onClick={() => playPodcastAndNavigate(podcast._id)}
        >
          <img
            src={podcast.coverImageUrl}
            alt={podcast.title}
            style={{
              width: "100%",
              height: "200px",
              objectFit: "cover",
              borderRadius: "8px",
              transition: "transform 0.3s ease",
            }}
          />
          <div
            className="position-absolute inset-0 rounded-3 d-flex align-items-center justify-content-center opacity-0 hover-overlay"
            style={{
              background: "rgba(0,0,0,0.6)",
              transition: "all 0.3s ease",
              zIndex: 2,
            }}
          >
            <i
              className="fas fa-play text-white"
              style={{ fontSize: "48px" }}
            ></i>
          </div>
        </div>

        <h3 className="live__title mt-3">
          <Link
            to={`/podcast-episode/${podcast._id}/podcast`}
            className="text-black text-decoration-none"
          >
            {podcast.title}
          </Link>
        </h3>
        <p className="live__artist text-muted">
          {podcast.artist || "Unknown Artist"}
        </p>
      </div>
    </div>
  );

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      {error && <div className="alert alert-danger">{error}</div>}

      {/* POPULAR PODCASTS */}
      <div className="row row--grid">
        <div className="col-12">
          <h2 className="card-title text-capitalize mt-3">
            Popular Podcasts
            <small className="text-muted ms-2">
              (Total: {allPopularPodcasts.length})
            </small>
          </h2>
        </div>

        {loadingPopular ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary"></div>
            <p>Loading popular podcasts...</p>
          </div>
        ) : (
          <>
            <div className="row">
              {popularPodcasts.map((podcast) => (
                <PodcastCard key={podcast._id} podcast={podcast} />
              ))}
            </div>
            <Pagination
              currentPage={popularCurrentPage}
              totalPages={popularTotalPages}
              onPageChange={handlePopularPageChange}
            />
          </>
        )}
      </div>

      {/* FEATURED PODCASTS */}
      <div ref={featuredSectionRef} className="row row--grid mt-5">
        <div className="col-12">
          <h2 className="card-title text-capitalize mt-3">
            Featured Podcasts
            <small className="text-muted ms-2">
              (Total: {allFeaturedPodcasts.length})
            </small>
          </h2>
        </div>

        {loadingFeatured ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary"></div>
            <p>Loading featured podcasts...</p>
          </div>
        ) : (
          <>
            <div className="row">
              {featuredPodcasts.map((podcast) => (
                <PodcastCard key={podcast._id} podcast={podcast} />
              ))}
            </div>
            <Pagination
              currentPage={featuredCurrentPage}
              totalPages={featuredTotalPages}
              onPageChange={handleFeaturedPageChange}
            />
          </>
        )}
      </div>

      {/* GENRES SLIDER */}
      <div className="row">
        <div className="col-lg-12 mb-5">
          <div className="card-header mb-3">
            <div className="header-title">
              <h4 className="card-title text-capitalize">Top genres for you</h4>
            </div>
            <div className="common-album position-relative d-lg-block d-none">
              <div
                className="swiper-button-prev"
                onClick={() => slidergenRef.current?.slickPrev()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
                    fill="#4A525F"
                  />
                </svg>
              </div>
              <div
                className="swiper-button-next"
                onClick={() => slidergenRef.current?.slickNext()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          </div>

          {loadingGenres ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "50vh" }}
            >
              <div className="spinner-border text-primary"></div>
            </div>
          ) : (
            <Slider
              ref={slidergenRef}
              {...settings}
              className="overflow-hidden"
            >
              {genres.map((genre) => (
                <div key={genre._id} className="mb-3 px-2">
                  <Link
                    to={`/podcasts/genre-podcasts`}
                    state={{
                      genreId: genre._id,
                      podcasts: genre.podcasts || [],
                      genreName: genre.genreName,
                    }}
                    className="text-decoration-none"
                  >
                    <img
                      src={
                        genre._id?.GenreImageUrl ||
                        `${process.env.PUBLIC_URL}/assets/images/dashboard/placeholder.png`
                      }
                      className="mb-3 img-fluid rounded-3"
                      alt={genre.genreName}
                      style={{ height: "220px", objectFit: "cover" }}
                    />
                    <div className="text-capitalize h5">{genre.genreName}</div>
                    <small className="text-muted">
                      {genre.podcasts
                        ? `${genre.podcasts.length} podcasts`
                        : "No podcasts"}
                    </small>
                  </Link>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>
    </div>
  );
}

export default Podcast;
